
/**
 * 除外ブロック1件分の中身。**入れ子を再帰で辿る。**
 *
 * 見た目はグループ側のカードではなく、モック（`todo/tickets/ui.html` パターン6）
 * と同じインラインの並びを保つ。V2 の `ExcludeItemBody` と同じ構造にすること。
 */
import Vue, { PropType } from 'vue';
import {
  ExtractionConditionGroup,
  ExtractionConditionRow,
  formatRowValues,
} from '@/views/pages/dynamicList/extractionConditions';

export default Vue.extend({
  // 自己参照で再帰するため name が要る
  name: 'ExcludeItemBody',
  props: {
    group: {
      type: Object as PropType<ExtractionConditionGroup>,
      required: true,
    },
  },
  methods: {
    formatValues(row: ExtractionConditionRow): string {
      return formatRowValues(row);
    },
  },
});
